import { t as theme } from '../themes/mobile-fusTO8VO.js';
import { M as MobileMode } from './MobileMode-DHJ6VHqt.js';
import { i as isMobileMediaQuery } from './isMobileMediaQuery-D1hSN0DH.js';
import { d as deepMerge } from '../../LocalModules/storm-ui-utils/dist/esm/deepMerge-DmW5IEKC-DLFdHXY0.js';

function createMobileTheme(mode) {
  return function mobileThemeGenerator(theme$1) {
    var _mobile;
    return deepMerge({}, theme$1, theme, {
      mobile: {
        mode,
        /* copy over the mobile mediaQuery if we are provided one */
        ...(isMobileMediaQuery(theme$1) ? {
          mediaQuery: theme$1 === null || theme$1 === void 0 || (_mobile = theme$1.mobile) === null || _mobile === void 0 ? void 0 : _mobile.mediaQuery
        } : {})
      }
    });
  };
}
const mobileAutoTheme = createMobileTheme(MobileMode.Auto);
const mobileEnableTheme = createMobileTheme(MobileMode.Enable);
const mobileDisableTheme = createMobileTheme(MobileMode.Disable);
function getMobileTheme(mode) {
  switch (mode) {
    case MobileMode.Enable:
      return mobileEnableTheme;
    case MobileMode.Disable:
      return mobileDisableTheme;
  }
  /* default to auto mode */
  return mobileAutoTheme;
}

export { getMobileTheme as g };
//# sourceMappingURL=getMobileTheme-CSMBAAVl.js.map
